module.exports = __webpack_public_path__ + "static/media/Lobby-Lounge.8f79c16b.jpg";